import { DASHBOARD_LABS_RV_VIEW, NORTHSTAR_METRICS_VIEW } from 'constants/capabilities';

exports.glossary = {
    actions: {
        definition: 'The total number of actions people took that are attributed to your ads. Actions may include engagement, clicks or conversions.',
        displayName: 'Actions'
    },
    ecpa_activities: {
        definition: 'The number of people who visit specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'eCPA Activities'
    },
    ecpa_activities_labelCode_sales: {
        definition: 'The number of purchases from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Sales Activities',
        labelCode: 'sales'
    },
    ecpa_activities_labelCode_leads: {
        definition: 'The number of leads generated from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Lead Activities',
        labelCode: 'leads'
    },
    ecpa_activities_labelCode_bookings: {
        definition: 'The number of bookings generated from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Booking Activities',
        labelCode: 'bookings'
    },
    campaign_activities: {
        definition: 'The number of people who visit specific pages tagged on website (i.e. homepage, landing page) or take specific actions (conversion, engagement, etc)',
        displayName: 'Campaign Activities'
    },
    campaign_activities_labelCode_sales: {
        definition: 'The number of sales from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Campaign Sales',
        labelCode: 'sales'
    },
    campaign_activities_labelCode_leads: {
        definition: 'The number of leads from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Campaign Leads',
        labelCode: 'leads'
    },
    campaign_activities_labelCode_bookings: {
        definition: 'The number of bookings from specific pages tagged on website (i.e. homepage, landing page)',
        displayName: 'Campaign Bookings',
        labelCode: 'bookings'
    },
    channelsLive: {
        definition: 'The number of Channels in the current selected date range with Impressions served. Tree Map is showing Budget per Channel.',
        displayName: 'Live Channels'
    },
    clicks: {
        definition: 'When someone clicks your ad, like on the blue headline of a text ad, that counts that as a "click".',
        displayName: 'Clicks'
    },
    completed_plays: {
        definition: 'Any view where a video ad starts and plays through its entire duration to completion.',
        displayName: 'Completed Plays'
    },
    completion_rate: {
        definition: 'The percentage of all video ads that play through their entire duration to completion.',
        displayName: 'Completion Rate'
    },
    conversions: {
        definition: 'A conversion is an action that a person takes on your website such as checking out, registering, adding an item to the shopping cart, or viewing a particular page.',
        displayName: 'Conversions'
    },
    cost_per_lead: {
        definition: 'The average cost of each lead. This metric is calculated as total amount spent divided by leads.',
        displayName: 'Cost Per Lead'
    },
    conversion_rate: {
        definition: 'The average number of conversions per ad click, shown as a percentage: conversions ÷ clicks = Conversion Rate',
        displayName: 'Conversion Rate'
    },
    cpc: {
        definition: 'Cost per Click (CPC) is the price an advertiser pays per generated user click: cost / clicks = CPC',
        displayName: 'CPC'
    },
    cpconv: {
        definition: 'Cost per Conversion (CPCONV) the price an advertiser pays to get one conversion',
        displayName: 'CPCONV'
    },
    cpcv: {
        definition: 'The price an advertiser pays every time a video ad runs through to completion.',
        displayName: 'CPCV'
    },
    ctr: {
        definition: 'CTR is the number of clicks that your ad receives divided by the number of times your ad is shown: clicks ÷ impressions = CTR.',
        displayName: 'CTR'
    },
    ecpa: {
        definition: 'Effective Cost per Action is the best metric to gauge campaign performance. Calculated as Budget/Website Actions (Activities).',
        displayName: 'eCPA'
    },
    ecpa_labelCode_sales: {
        definition: 'Effective Cost per Sale is the best metric to gauge campaign performance.',
        displayName: 'Cost Per Sale',
        labelCode: 'sales'
    },
    ecpa_labelCode_leads: {
        definition: 'Effective Cost per Lead is the best metric to gauge campaign performance.',
        displayName: 'Cost Per Lead',
        labelCode: 'leads'
    },
    ecpa_labelCode_bookings: {
        definition: 'Effective Cost per Booking is the best metric to gauge campaign performance.',
        displayName: 'Cost Per Booking',
        labelCode: 'bookings'
    },
    engagements: {
        definition: 'The total number of actions that people take involving your ads, such as reacting to, commenting on or sharing the ad, claiming an offer, viewing a photo or video, or clicking on a link.',
        displayName: 'Engagements'
    },
    impressions: {
        definition: 'An impression is the act of displaying of a creative on a webpage. The same creative served two separate times would count as two impressions.',
        displayName: 'Impressions'
    },
    leads: {
        definition: 'Any lead event that has been attributed to your ads, such as a Facebook pixel, app SDK, or offline event set.',
        displayName: 'Leads'
    },
    reach: {
        definition: 'The average Reach per (month, week, day) in the current date range. Reach is the number of people who viewed your ads at least once. Reach is different from impressions, which may include multiple views of your ads by the same people',
        displayName: 'Reach'
    },
    reach_median: {
        definition: 'The span of Reach through quartiles across the (months, weeks, days) of the current date range. The median is marked by a vertical line inside the box while the lines extending parallel are used to indicate the variability outside the upper and lower quartiles.',
        displayName: 'Reach (Median)'
    },
    started_plays: {
        definition: 'Any view where a video ad starts to play.',
        displayName: 'Started Plays'
    },
    spend: {
        definition: 'Total spent for all advertising matching the current filters.',
        displayName: 'Spend'
    },
    video_views: {
        definition: 'The number of times your ad has been viewed. A "view" is when a viewer engages with or watches 30 seconds of your in-stream video (or all of it, for shorter videos). Or, for TrueView video discovery, this is the number of times viewers click a thumbnail to watch your video.',
        displayName: 'Video Views'
    },
    video_view_rate: {
        definition: 'The percentage of time your ad is viewed, relative to the total number of times your ad is shown. (Video Views / Impressions)',
        displayName: 'Video View Rate'
    },
    cpvv: {
        definition: 'Cost per Video View (Spend / Video Views)',
        displayName: 'CPVV'
    },
    cost_per_link_click: {
        definition: 'The average cost of each Link Click. This metric is calculated as total amount spent divided by link clicks.',
        displayName: 'Cost Per Link Click'
    },
    link_clicks: {
        definition: 'Link Clicks are the number of clicks on links to select destinations or experiences, on or off Facebook-owned properties.',
        displayName: 'Link Clicks'
    },
    mobile_app_installs: {
        definition: 'App installs are the number of times the app was installed on a mobile device.',
        displayName: 'App Installs'
    },
    event_responses: {
        definition: 'Event Responses are the number of RSVPs submitted to the tracked event.',
        displayName: 'Event Responses'
    },
    page_likes: {
        definition: 'Page Likes are the number of times a user clicked the "like" button on a page.',
        displayName: 'Page Likes'
    },
    // Note - scope is broken on the below definitions as the currentUser object used to retrieve current scope
    // in the higher component never actually retrieves anything from state. For the purpose of this, adding a
    // scope to a definition *removes it altogether* from the glossary.
    north_star_active_dashboards: {
        definition: 'Number of Dashboards and the associated child Dashboards viewed at least once by a Client over the last 30 days.',
        displayName: 'North Star - Active Dashboards',
        scope: [NORTHSTAR_METRICS_VIEW]
    },
    north_star_eligible_dashboards: {
        definition: 'Number of Dashboards and the associated child Dashboards with at least one Client assigned to them over the last 30 days.',
        displayName: 'North Star - Eligible Dashboards',
        scope: [NORTHSTAR_METRICS_VIEW]
    },
    north_star_platforms: {
        definition: 'Number of Platforms avaliable for use in the Dashboards',
        displayName: 'North Star - Avaliable Platforms',
        scope: [NORTHSTAR_METRICS_VIEW]
    },
    north_star_metric: {
        definition: '% of Active Dashboards where a Client has logged in to view the Dashboard at least 1 time in the last 30 days. North Star = (Active Dashboards / Eligible Dashboards)',
        displayName: 'North Star Metric',
        scope: [NORTHSTAR_METRICS_VIEW]
    },
    acpa: {
        definition: 'Attributed CPA. Ration between weighted attributed conversions (see definition above) and total partner spend as reported in the TTD impression and conversion logs for the period of time specified.',
        displayName: 'aCPA',
        scope: [DASHBOARD_LABS_RV_VIEW]
    },
    weighted_attributed_conversions: {
        definition: 'Fraction of conversion that can be attributed to the spend in a specific period of time, given a 30-day attribution window. For example, if we have specific TDID user that generated 100 conversions with 50 impression during for the last 30 days, each impression will get an attributed conversion weight of 2. If we are looking at a day where 10 of those impressions were served, then the attributed conversions for that day will be 20 (10x2)',
        displayName: 'Weighted Attributed Conversions',
        scope: [DASHBOARD_LABS_RV_VIEW]
    },
    attributed_impressions: {
        definition: 'Number of impressions that can be attributed to a conversion. All of these impressions will be associated with a user TDID that has resulted in a conversion within the 30-day period since the impression was delivered. ',
        displayName: 'Attributed Impressions',
        scope: [DASHBOARD_LABS_RV_VIEW]
    }
};




// WEBPACK FOOTER //
// ./src/constants/glossary.js